import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactToggle from "react-toggle";
import "react-toggle/style.css";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from '../../store/Functions';
import { API_WEB_URLS } from '../../constants/constAPI';

function AddEdit_MCQMasterH() {
    const API_URL = API_WEB_URLS.MASTER + "/0/token/UserType"; 
    const API_URL_SAVE = `${API_WEB_URLS.McqMasterH}/0/token`;
    const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/McqMasterEdit/Id`;
  
    const [state, setState] = useState({
            Title: '',
            Duration: '',
            F_UserType: '',
            DistributeTime: false,
            PreviousOn: false,
            TestDateTime: '',  // New field for date and time
            Amount: '',
            Brightness: '',
            id: 0,
        FillArray: [],
        formData: {
    },
        isProgress: true,
    });

    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const Id = (location.state && location.state.Id) || 0;
        Fn_FillListData(dispatch, setState, 'FillArray', API_URL + '/Id/0');
        if (Id > 0) {
            setState(prevState => ({
                ...prevState,
                id: Id
            }));
            Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
        }
    }, [location.state, dispatch]);

    // Form validation schema
    const validationSchema = Yup.object({
        Title: Yup.string().required('Title is required'),
        Duration: Yup.number().required('Duration is required').positive('Duration must be positive'),
     
        F_UserType: Yup.string().required('User Type is required'),
        TestDateTime: Yup.string().required('Test Date and Time is required'),
    });

    // Form submit handler
    const handleSubmit = (values) => {
        const date = new Date(values.TestDateTime);
    
        // Get local date and time components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = '00'; // Set seconds to 00, adjust if needed
    
        // Format the date as YYYY-MM-DD HH:MM:SS
        const formattedTestDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    
        const formData = new FormData();
        formData.append("Title", values.Title);
        formData.append("Duration", values.Duration);
        formData.append("F_UserType", values.F_UserType);
        formData.append("Amount", values.Amount);
        formData.append("Brightness", values.Brightness);
        formData.append("DistributeTime", values.DistributeTime);
        formData.append("PreviousOn", values.PreviousOn);
        formData.append("TestDate", formattedTestDateTime);  // Add formatted TestDateTime
    
        Fn_AddEditData(
            dispatch,
            setState,
            { arguList: { id: state.id, formData } },
            API_URL_SAVE,
            true,
            "memberid"
        );
    };
    

    return (
        <div className='page-content'>
            <Formik
                initialValues={state.formData}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ setFieldValue, values }) => (
                    <Form className="form-horizontal">
                        {/* UserType field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="F_UserType" className="form-label">User Type</label>
                                <Field className="form-control" as="select" name="F_UserType">
                                    <option value="">Select UserType</option>
                                    {state.FillArray.length > 0 && state.FillArray.map((UserType) => (
                                        <option key={UserType.Id} value={UserType.Id}>{UserType.Name}</option>
                                    ))}
                                </Field>
                                <ErrorMessage name="F_UserType" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Title field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="Title" className="form-label">Title</label>
                                <Field className="form-control" type="text" name="Title" />
                                <ErrorMessage name="Title" component="div" className="text-danger" />
                            </Col>
                        </Row>
                        
                        {/* Duration field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="Duration" className="form-label">Duration (in hours)</label>
                                <Field className="form-control" type="number" name="Duration" />
                                <ErrorMessage name="Duration" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Amount field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="Amount" className="form-label">Amount</label>
                                <Field className="form-control" type="number" name="Amount" />
                                <ErrorMessage name="Amount" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Brightness field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="Brightness" className="form-label">Brightness</label>
                                <Field className="form-control" type="number" name="Brightness" />
                                <ErrorMessage name="Brightness" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Test Date and Time field */}
                        <Row>
                            <Col lg='6' className="mb-3">
                                <label htmlFor="TestDateTime" className="form-label">Test Date and Time</label>
                                <Field
                                    className="form-control"
                                    type="datetime-local"
                                    name="TestDateTime"
                                />
                                <ErrorMessage name="TestDateTime" component="div" className="text-danger" />
                            </Col>
                        </Row>
                        
                        {/* Distributive Time toggle */}
                        <Row>
                            <Col lg='2' className="mb-3">
                                <label className="form-label">Distributive Time</label>
                            </Col>
                            <Col lg='1' className="mb-3">
                                <ReactToggle
                                    checked={values.DistributeTime}
                                    onChange={() => setFieldValue('DistributeTime', !values.DistributeTime)}
                                />
                                <ErrorMessage name="DistributeTime" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Previous On toggle */}
                        <Row>
                            <Col lg='2' className="mb-3">
                                <label className="form-label">Previous On</label>
                            </Col>
                            <Col lg='1' className="mb-3">
                                <ReactToggle
                                    checked={values.PreviousOn}
                                    onChange={() => setFieldValue('PreviousOn', !values.PreviousOn)}
                                />
                                <ErrorMessage name="PreviousOn" component="div" className="text-danger"/>
                            </Col>
                        </Row>

                        {/* Submit button */}
                        <button type="submit" className="btn btn-primary btn-block">Submit</button>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default AddEdit_MCQMasterH;
